// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"styles_blockWrapper__by248","textInfo":"styles_textInfo__bJrqG","descriptionBlock":"styles_descriptionBlock__2TxQG","optionWrapper":"styles_optionWrapper__mSWZl"};